/* ==========================================================================
   SKÉINA SKINCARE — Such-Kern
   Gemeinsame Normalisierung, Synonyme und Treffer-Bewertung für
   - das Such-Overlay (sections/skn-search.liquid)
   - den Fallback der Suchseite (sections/skn-search-page.liquid)
   Datenquelle: /collections/all?view=skn-index (templates/collection.skn-index.liquid)

   Die Synonymliste ist reine Suchhilfe. Sie erscheint nirgends als Text,
   es entstehen dadurch keine Wirkversprechen im Shop.
   ========================================================================== */

(function () {
  'use strict';
  if (window.SknSearchCore) return;

  /* Klein, ohne Akzente, ß -> ss, ae/oe/ue -> a/o/u (beidseitig gleich
     angewendet, damit "roetung" und "rötung" dasselbe finden). */
  function norm(s) {
    return String(s == null ? '' : s)
      .toLowerCase()
      .replace(/ß/g, 'ss')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* Mehrwort-Ausdrücke vor dem Zerlegen ersetzen (auf normalisiertem Text). */
  var PHRASES = [
    [/\bmake ?up (entfernen|entferner|entfernung|runter|weg)\b/g, 'reinigung'],
    [/\b(gesicht|gesichts) ?(reinigen|reinigung|waschen)\b/g, 'reinigung'],
    [/\b(gruner|grun) tee\b/g, 'gruntee'],
    [/\bgreen tea\b/g, 'gruntee'],
    [/\bvitamin b ?3\b/g, 'niacinamid'],
    [/\banti ?falten\b/g, 'falten'],
    [/\bgrosse poren\b/g, 'poren'],
    [/\bunreine haut\b/g, 'unreinheiten']
  ];

  /* Suchwort (normalisiert) -> zusätzliche Begriffe, die im Index stehen.
     Schlüssel ab 4 Zeichen greifen auch als Wortanfang ("pickelig" -> "pickel"). */
  var SYNONYMS = {
    pickel: ['unreinheit'],
    pickelig: ['unreinheit'],
    akne: ['unreinheit'],
    mitesser: ['unreinheit', 'poren'],
    pusteln: ['unreinheit'],
    unrein: ['unreinheit'],
    glanz: ['fettige haut'],
    glanzend: ['fettige haut'],
    olig: ['fettige haut'],
    rosacea: ['rotung'],
    couperose: ['rotung'],
    rot: ['rotung'],
    rote: ['rotung'],
    gerotet: ['rotung'],
    sensibel: ['empfindlich'],
    sensible: ['empfindlich'],
    irritiert: ['gereizt'],
    brennen: ['gereizt'],
    falten: ['anti aging', 'linien', 'spannkraft'],
    faltchen: ['anti aging', 'linien'],
    knitterfaltchen: ['anti aging', 'linien'],
    altern: ['anti aging'],
    alterung: ['anti aging'],
    antiaging: ['anti aging'],
    ageing: ['anti aging'],
    straff: ['spannkraft'],
    straffung: ['spannkraft'],
    elastizitat: ['spannkraft'],
    abschminken: ['reinigung', 'make up entferner'],
    makeup: ['make up'],
    reiniger: ['reinigung'],
    reinigen: ['reinigung'],
    gesichtsreinigung: ['reinigung'],
    cleanser: ['reinigung'],
    micellar: ['mizellenwasser'],
    mizellar: ['mizellenwasser'],
    mizelle: ['mizellenwasser'],
    hyaluronic: ['hyaluron'],
    niacinamide: ['niacinamid'],
    cica: ['madecassoside'],
    centella: ['madecassoside'],
    probiotika: ['laktobazillus'],
    probiotisch: ['laktobazillus'],
    lactobacillus: ['laktobazillus'],
    ferment: ['laktobazillus'],
    zink: ['zinkgluconat'],
    zinc: ['zinkgluconat'],
    peptid: ['peptide'],
    feuchtigkeit: ['feuchtigkeitsspendend', 'hyaluron'],
    trocken: ['trockene haut', 'trocken'],
    bundle: ['set'],
    kombi: ['set'],
    duo: ['set'],
    routine: ['set', 'routine'],
    essenz: ['essence'],
    serum: ['essence', 'serum']
  };

  var STOP = ['fur', 'gegen', 'bei', 'und', 'mit', 'die', 'der', 'das', 'den', 'dem', 'ein', 'eine', 'einen',
    'von', 'zum', 'zur', 'ich', 'mein', 'meine', 'was', 'hilft', 'welches', 'welche', 'auf', 'im', 'in', 'am', 'an', 'ist'];

  function alternatives(t) {
    var out = [];
    Object.keys(SYNONYMS).forEach(function (key) {
      var hit = key === t || (key.length >= 4 && t.length >= 4 && t.indexOf(key) === 0);
      if (hit) {
        SYNONYMS[key].forEach(function (alt) {
          if (alt !== t && out.indexOf(alt) === -1) out.push(alt);
        });
      }
    });
    return out;
  }

  function tokenize(q) {
    var n = ' ' + norm(q) + ' ';
    PHRASES.forEach(function (ph) { n = n.replace(ph[0], ph[1]); });
    var seen = {};
    return n.trim().split(' ').filter(function (t) {
      if (t.length < 2 || STOP.indexOf(t) > -1 || seen[t]) return false;
      seen[t] = true;
      return true;
    });
  }

  function list(v) {
    if (!v) return '';
    return Array.isArray(v) ? v.join(' ') : String(v);
  }

  /* Index-Eintrag vorbereiten. Liefert die Felder, die das Overlay erwartet
     (p, nm, name, topics, goals, rest) plus tags. */
  function prepare(p) {
    var nm = p.t || '';
    var tagText = p.tg ? list(p.tg) : list(p.g);
    return {
      p: p,
      nm: nm,
      name: norm(nm + ' ' + nm.replace(/[\s-]/g, '')),
      tags: norm([tagText, p.ty, list(p.pz), list(p.ht), list(p.pf)].join(' ')),
      topics: norm(p.k),
      goals: norm(list(p.pz) + ' ' + list(p.ht)),
      rest: norm(p.d)
    };
  }

  function wordStart(field, t) { return (' ' + field).indexOf(' ' + t) > -1; }
  function wordExact(field, t) { return (' ' + field + ' ').indexOf(' ' + t + ' ') > -1; }

  function scoreTerm(e, t) {
    var short = t.length <= 3;
    var s = 0;
    if (e.name.indexOf(t) === 0) s = 9;
    else if (wordStart(e.name, t)) s = 7;
    else if (!short && t.length >= 4 && e.name.indexOf(t) > -1) s = 5;

    if (wordExact(e.tags, t)) s = Math.max(s, 7);
    else if (!short && wordStart(e.tags, t)) s = Math.max(s, 6);
    else if (t.length >= 5 && e.tags.indexOf(t) > -1) s = Math.max(s, 4);

    if (short ? wordExact(e.topics, t) : wordStart(e.topics, t)) s = Math.max(s, 4);
    else if (t.length >= 5 && e.topics.indexOf(t) > -1) s = Math.max(s, 3);

    if (short ? wordExact(e.rest, t) : wordStart(e.rest, t)) s = Math.max(s, 2);
    else if (t.length >= 6 && e.rest.indexOf(t) > -1) s = Math.max(s, 1);
    return s;
  }

  function scoreToken(e, t) {
    var best = scoreTerm(e, t);
    alternatives(t).forEach(function (alt) {
      best = Math.max(best, Math.max(scoreTerm(e, alt) - 1, 0));
    });
    return best;
  }

  function sortHits(a, b) {
    return (b.matched - a.matched)
      || (b.score - a.score)
      || (a.e.p.s === b.e.p.s ? 0 : (a.e.p.s ? 1 : -1))
      || String(a.e.nm).localeCompare(String(b.e.nm), 'de');
  }

  /* Liefert [{ e, score, matched }]. Erst alle Wörter müssen passen (UND).
     Findet das nichts, zählen Teiltreffer (z. B. "creme gegen pickel"). */
  function rank(q, index) {
    var tokens = tokenize(q);
    if (!tokens.length || !index || !index.length) return [];
    var strict = [], partial = [];
    index.forEach(function (e) {
      var score = 0, matched = 0;
      tokens.forEach(function (t) {
        var s = scoreToken(e, t);
        if (s) { matched++; score += s; }
      });
      if (!matched) return;
      var hit = { e: e, score: score, matched: matched };
      if (matched === tokens.length) strict.push(hit); else partial.push(hit);
    });
    var out = strict.length ? strict : partial;
    out.sort(sortHits);
    out.partial = !strict.length && partial.length > 0;
    return out;
  }

  var indexPromises = {};
  function loadIndex(url) {
    if (indexPromises[url]) return indexPromises[url];
    indexPromises[url] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (list) { return (list || []).map(prepare); })
      .catch(function (err) { delete indexPromises[url]; throw err; });
    return indexPromises[url];
  }

  window.SknSearchCore = {
    norm: norm,
    tokenize: tokenize,
    prepare: prepare,
    rank: rank,
    loadIndex: loadIndex,
    synonyms: SYNONYMS
  };
})();
